<template>
    <div id="blocks-search-container">
        <v-text-field
            @input="onInput"
            v-model="searchTerm"
            id="block-search-input"
            ref="block-search"
            class="search-container"
            append-icon="search"
            placeholder="Search Tools"
            dark
            flat
            solo
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
        ></v-text-field>
    </div>
</template>

<script>
export default {
    mounted() {
        this.$root.$refs.blockSearch = this.$refs['block-search'];
    },

    data() {
        return {
            searchTerm: null,
        };
    },

    methods: {
        onInput() {
            this.$store.dispatch('UI/setBlockListSearchTerm', this.searchTerm);
        }
    },

};
</script>

<style lang="scss" scoped>
#blocks-search-container {
    ::v-deep .search-container {
        width: 100%;
        flex: initial;
        border: 1px solid var(--font-default-color);
        border-radius: 25px;

        .v-input__slot {
            padding: 0 12px 0 20px;
            background: transparent;
        }

        &.v-input--is-dirty {
            border-color: var(--color-accent);

            .mdi-close-circle-outline,
            .mdi-close-circle-outline:before {
                color: var(--color-accent);
            }
        }

        input,
        .v-label {
            font-size: 1rem;
            color: var(--font-default-color);
            font-weight: normal;
        }

        .v-icon,
        .v-icon:before {
            font-size: 18px;
            color: var(--font-default-color);
        }

        .v-input__control {
            min-height: initial;
        }
    }
}
</style>
